<template>
  <FlotoDropdownPicker
    v-if="!disabled"
    v-model="currentValue"
    as-input
    searchable
    :options="options"
  />
  <span v-else>
    {{
      currentValue || currentValue === 0
        ? (options.find((o) => o.key === currentValue) || {}).text
        : '---'
    }}
  </span>
</template>

<script>
import Range from 'lodash/range'
import Moment from 'moment'

export default {
  name: 'HourInput',
  model: { event: 'change' },
  props: {
    value: { type: Number, default: undefined },
    disabled: { type: Boolean, default: false },
  },
  data() {
    this.options = [
      {
        text: Moment('24:00', 'H:mm').format('hh:mm A'),
        key: 0,
      },
    ]
    Range(1, 24).forEach((r) => {
      this.options.push({
        text: Moment(`${r}:00`, 'H:mm').format('hh:mm A'),
        key: r,
      })
    })
    return {}
  },
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('change', v)
      },
    },
  },
}
</script>
